module.exports = __webpack_public_path__ + "img/gift.2e13f8c6.png";